import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { ThemeToggle } from "@/theme/ThemeToggle";

/**
 * Header global com link "Goyaz" e o toggle de tema.
 * Páginas envolvem seu conteúdo com `<AppShell>` quando querem o
 * header aparecendo (Dashboard, Deploy, NewProject, etc).
 *
 * Telas full-screen sem header (Login, Setup) podem renderizar sem
 * AppShell.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-app-bg text-app-text">
      <header className="border-b border-app-border bg-app-surface">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/dashboard" className="font-bold text-lg">
            Goyaz
          </Link>
          <ThemeToggle />
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
